$(document)
    .on('change', '[data-education] [name]', function () {
        items.update('education');
    })
    .on('click', '[data-industry-pc] label', function (e) {
        e.preventDefault();

        var input = $(this).prev();

        if (input.prop('checked')) {
            input.prop('checked', false);
        } else {
            input.prop('checked', true);
        }

        input.trigger('change');
    });

export default () => {
    var data = {
        category_id: [],
        type_id: []
    };

    if ($('[data-education] [name="category_id"]:checked').length) {
        $('[data-education] [name="category_id"]:checked').each(function () {
            data.category_id.push($(this).val());
        });
    }

    if ($('[data-education] [name="type_id"]:checked').length) {
        $('[data-education] [name="type_id"]:checked').each(function () {
            data.type_id.push($(this).val());
        });
    }

    if ($('[data-education] [name="industry_id"]:checked').length) {
        if ($(window).width() > 767) {
            data.industry_id = $('[data-industry-pc] [name="industry_id"]:checked').val();
        } else {
            data.industry_id = $('[data-industry-mobile] [name="industry_id"]:checked').val();
        }
    }

    return data;
}